export const routes = (prefix = `reports`, pre = `patients`) => [
    {
        name: `${prefix}.${pre}.ip-diagnosis-report.index`,
        path: `/${prefix}/${pre}/ip-diagnosis-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.ip-diagnosis-report.index`,
                PageDescription: "Patient Reports: IP Diagnosis report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.print.ip-diagnosis-report.index`,
        path: `/${prefix}/${pre}/ip-diagnosis-report/print`,
        component: () => import('./prints/IPDiagnosisReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.ip-diagnosis-report.index`,
                PageDescription: "Patient Reports: IP Diagnosis report",
            },
            print: true,
        },
    },
];